import { useEffect } from 'react';
import { Canvas } from 'fabric';
import { applyCanvasFrameClip } from '../utils/canvas-frame-clip';

// Re-applies on layoutVersion change because loadFromJSON wipes canvas.clipPath.
export function useCanvasClip(
  canvas: Canvas | null,
  enabled: boolean,
  width: number,
  height: number,
  layoutVersion: number
): void {
  useEffect(() => {
    if (!canvas) return;
    if (enabled) {
      applyCanvasFrameClip(canvas, width, height);
    } else {
      canvas.clipPath = undefined;
    }
    canvas.requestRenderAll();
  }, [canvas, enabled, width, height, layoutVersion]);
}
